var GlobalEventListeners = function(gal) {
    var _this = this,
        fireBrochureView = true,
        _notificationAnimPlayed = false,
        _triggerAppPromoPopup = false,
        _notificationPlayed = {};

    _this.slidedPagesCnt = 0;

    function _xmlEvents() {
        $(document).on('click', '.product-zone', function(e) {
            // if(typeof viewSettings.isRedesign !== 'undefined' && viewSettings.isRedesign === true){
            //     fireEvent(window, 'view.xml.product.onclick', $(this));
            // }
            
            e.preventDefault();
        });
    }

    function _sendGaEventLastPage() {
        if (fireBrochureView) {
            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'Brochure:view', 'last-page-view');
            }

            fireBrochureView = false;
        }
    }

    function _showNavigationLastPage() {
        if (navigation.navIsOpen() === false) {
            navigation.toggleNav();
        }
    }

    function _buttonEvents() {
        var device = isMobile ? 'mobile' : 'desktop';

        $(document).on('click', '#btn-notification', function(e) {
            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'bell', device, brandName);
            }

            fromNotificationButton = true;
        });

        $(document).on('click', '.view-related .catalog, .related-brochures-page .catalog', function(e) {
            var linkTo = $(this).find('a')[0].href,
                linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'related_back_' + device, linkTo, linkFrom);
            }
        });

        $(document).on('click', '#related-content .catalog', function(e) {
            var linkTo = $(this).find('a')[0].href,
                linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'related_scroll', linkTo, linkFrom);
            }
        });

        $(document).on('click', '#btn-back', function(e) {
            var linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'back_view', device, linkFrom);
            }
        });

        $(document).on('click', '#btn-tags', function(e) {
            var linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'products_list', device, linkFrom);
            }
        });

        $(document).on('click', '#btn-pages', function(e) {
            var linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'pages_list', device, linkFrom);
            }
        });


        $(document).on('click', '.view-buttons-wrap.next-brochure, #btn-next-brochure', function(e) {
            var linkTo = viewSettings.relatedBrochure.brochure_link,
                linkFrom = location.href;

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'next_brochure_' + device, linkTo, linkFrom);
            }
        });

        if (isMobile) {
            $(document).on('click', '#close-mobile', function(e) {
                var action = navigation.navIsOpen() ? 'open' : 'close';

                if (typeof ga !== 'undefined') {
                    ga('send', 'event', 'menu_mobile', 'Click ' + action);
                }
            });
        }
    }

    function _additionalPageEvents() {
        $(document).on('click', '.specific-promo-page area, #promo-last-page', function(e) {
            if(typeof viewSettings.isRedesign === 'undefined' || viewSettings.isRedesign === false){
                e.preventDefault();
            }
        });

        window.addEventListener('view.specific.promo.page.onclick', function(event) {
            var device = isMobile ? 'mobile' : 'desktop',
                category = "Inside-Page",
                action = device + '-' + brochureSeoUrl + '-last-page',
                // label = event.customMessage;
                label = 'black-friday-2017', //TODO change this value when this should be used for general purpose
                newWindow;

            event.preventDefault();
            if (typeof ga !== 'undefined') {
                ga('send', 'event', category, action, label);
            }

            if(isMobile){
                setTimeout(function(){
                    window.location.href = event.customMessage;
                }, 10);
            }else{
                newWindow = window.open(event.customMessage, "_blank");
                newWindow.opener = null;
            }
        });

        window.addEventListener('view.app.promo.page.onclick', _openUrlInNewWindow);
        window.addEventListener('view.last.page.banner.onclick', _openUrlInNewWindow);
    }

    function _openUrlInNewWindow(event){
        event.preventDefault();
        var el = event.customMessage,
            ec = $(el).data('ga-category') || '',
            ea = $(el).data('ga-action') || '';

        if(ec && ea){
            ga('send', 'event', ec, ea);
        }

        var newWindow = window.open(el.href, "_blank");
        newWindow.opener = null;
    }

    function _animateBtn(id, animationName){
        if(id in _notificationPlayed == false){
            helpers.toggleBtnAnimation(id, animationName)
            _notificationPlayed[id] = true;
        }
    }

    function _init() {

        // window.addEventListener('view.first.page.show', function(event){
        // }, true);

        window.addEventListener('view.last.page.show', function(event) {
            _sendGaEventLastPage();

            if (isMobile) {
                _showNavigationLastPage();
            }
        }, true);

        window.addEventListener('view.pin.onclick', function(event) {
            var $el = event.customMessage,
                newWindow = window.open($el.data('url'), "_blank"),
                pageInx = $('.slide-img').length ? $el.closest('.page').find('.slide-img').data('page-inx') : $el.parent().find('img').data('page-inx'),
                label = $el.data('type') == 1 ? 'blue' : 'green',
                action = $el.data('real-url');

            newWindow.opener = null;

            if(typeof gal.isAdditionalPage !== 'undefined' && gal.isAdditionalPage(pageInx)){
                (gal.jsonData.type === ViewConsts.xml) ? ga('send', 'event','XML product' ,'inside-page', action) : ga('send', 'event', 'Inside-Page', action);
            }else{
                ga('send', 'event', 'Pin:' + label, action);
            }
            
            if(typeof goog_report_conversion !== 'undefined' && typeof goog_report_conversion === 'function'){
                goog_report_conversion(action, true);
            }

            if(typeof fbq !== 'undefined' && typeof fbq === 'function' && typeof FbConversionValue !== 'undefined' && typeof FbContentType !== 'undefined'){
                fbq('track', 'ViewContent', { 
                    'value': FbConversionValue, 
                    'content_type': FbContentType
                });
            }
        }, true);

        window.addEventListener('view.onpagechange', function(event) {
            _this.slidedPagesCnt++;
            
            if(isMobile == false){
                _animateBtn('btn-notification', 'tada');
            }

            if(isMobile && _this.slidedPagesCnt == 2 && _triggerAppPromoPopup){
                _triggerAppPromoPopup = false;
                fireEvent(window, 'view.app.promo.show.popup');
            }

            if(!isMobile && _this.slidedPagesCnt == 1){
                _animateBtn('btn-app-landing', 'tada');
            }

        }, true);

        _buttonEvents();
        _additionalPageEvents();

        if (gal.jsonData.type === ViewConsts.xml) {
            _xmlEvents();

            window.addEventListener('view.xml.product.onclick', function(event) {
                console.log('%c view.xml.product.onclick', 'color: orange');
                var el = event.customMessage ? event.customMessage[0] : event.customMessage,
                    action = el.getAttribute('data-real-url'),
                    category = 'XML product',
                    newWindow;

                newWindow = window.open(el.href, "_blank");
                newWindow.opener = null;

                (el.dataset.productType === "1") ? ga('send', 'event', category, 'banner-click', action) : ga('send', 'event', category, action);
                
                if(typeof fbq !== 'undefined' && typeof fbq === 'function' && typeof FbConversionValue !== 'undefined' && typeof FbContentType !== 'undefined'){
                    fbq('track', 'ViewContent', { 
                        'value': FbConversionValue, 
                        'content_type': FbContentType
                    });
                }
                event.preventDefault();
            });
        }
    }

    _this.init = _init;
    _this.xmlEvents = _xmlEvents;
};